// @core/api/endpoints/localization/create_glossary_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateGlossaryEntryRequest,
  GlossaryEntryResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Create glossary entry
 * Creates a glossary entry for consistent terminology across products.
 */
export async function CreateGlossaryEntry(
  data: CreateGlossaryEntryRequest,
  options?: RequestOptions
): Promise<GlossaryEntryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/glossary`;
  const requestOptions = options;
  return client.post<GlossaryEntryResponse>(requestPath, data, requestOptions);
}
